import { Component } from '@angular/core';
import { LeaderboardType, LeaderboardV2Entry, LeaderboardV2Query, LeaderboardV2Service } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import * as _moment from 'moment';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'fgb-fantasy-games-page',
  templateUrl: './fantasy-games-page.component.html',
  styleUrls: ['./fantasy-games-page.component.scss'],
})
export class FantasyGamesPageComponent {
  screenType = ScreenType;
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
  currentUser: LeaderboardV2Entry | undefined;

  constructor(
    private leaderboardV2Service: LeaderboardV2Service,
    private leaderboardV2Query: LeaderboardV2Query
  ) {}

  ngOnInit() {
    firstValueFrom(this.leaderboardV2Service.fetchLeaderboardV2(undefined, this.LeaderboardType)).then(() => {
      this.currentUser = this.leaderboardV2Query.getLeaderboardV2().find((entry) => entry.IsCurrentUser);
    });
  }
}
